// Generated by Melange

import QueueModuleCss from "./queue.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Shared__Button from "./button.jsx";
import * as Shared__Container from "./container.jsx";
import * as Shared__H2 from "./h2.jsx";
import * as Shared__QueueContext from "./queueContext.jsx";
import * as Shared__ScrollLock from "./scrollLock.jsx";
import * as Shared__SongList from "./songList.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as Webapi__Dom__Document from "melange-webapi/Webapi/Dom/Webapi__Dom__Document.jsx";
import * as Webapi__Dom__Element from "melange-webapi/Webapi/Dom/Webapi__Dom__Element.jsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = QueueModuleCss;

function Queue(Props) {
  let id = Props.id;
  let triggerRef = Props.triggerRef;
  const rootRef = React.useRef(null);
  const currentSongId = Store__Context.useAppStore(function (state) {
    return state.player.currentSongId;
  });
  const queuedSongIds = Store__Context.useAppStore(function (state) {
    return state.player.queuedSongIds;
  });
  const lockScroll = Shared__ScrollLock.use(undefined);
  const match = Shared__QueueContext.Context.use(undefined);
  const setIsOpen = match.setIsOpen;
  const isOpen = match.isOpen;
  const currentSongIdRef = React.useRef(currentSongId);
  React.useEffect((function () {
    currentSongIdRef.current = currentSongId;
  }), [currentSongId]);
  React.useEffect((function () {
    if (isOpen) {
      Curry._1(lockScroll, true);
      Stdlib__Option.iter((function (currentSongId) {
        const currentSongElement = document.getElementById("now-playing-queue-" + currentSongId);
        const currentSongElement$1 = (currentSongElement == null) ? undefined : Caml_option.some(currentSongElement);
        Stdlib__Option.iter((function (prim) {
          prim.focus();
        }), Stdlib__Option.bind(Stdlib__Option.bind(currentSongElement$1, (function (param) {
          return Caml_option.nullable_to_opt(param.querySelector("button"));
        })), Webapi__Dom__Element.asHtmlElement));
        const partial_arg = {
          behavior: "instant",
          block: "end"
        };
        Stdlib__Option.iter((function (param) {
          param.scrollIntoView(partial_arg);
        }), Stdlib__Option.bind(currentSongElement$1, Webapi__Dom__Element.asHtmlElement));
      }), currentSongIdRef.current);
    } else {
      const activeElement = Stdlib__Option.bind(Webapi__Dom__Document.asHtmlDocument(document), (function (prim) {
        return Caml_option.nullable_to_opt(prim.activeElement);
      }));
      const match = rootRef.current;
      const match$1 = triggerRef.current;
      if (activeElement !== undefined && !(match == null) && match$1 !== undefined && match.contains(Caml_option.valFromOption(activeElement))) {
        Caml_option.valFromOption(match$1).focus();
      }
      
    }
    return (function (param) {
      Curry._1(lockScroll, false);
    });
  }), [
    isOpen,
    lockScroll,
    triggerRef
  ]);
  return JsxRuntime.jsxs("div", {
    ref: rootRef,
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Shared__Container.make, {
          children: [
            JsxRuntime.jsx(Shared__H2.make, {
              children: "Now playing"
            }),
            JsxRuntime.jsx(Shared__Button.make, {
              ariaLabel: "Close",
              children: JsxRuntime.jsx(LucideReact$1.X, Curry._4(LucideReact.X.makeProps, undefined, undefined, "none", undefined)),
              className: css.headerCloseButton,
              variant: "icon",
              onClick: (function (param) {
                Curry._1(setIsOpen, (function (param) {
                  return Stdlib__Fun.$$const(false, param);
                }));
              })
            })
          ],
          className: css.headerContainer
        }),
        className: css.header
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Shared__Container.make, {
          children: JsxRuntime.jsx(Shared__SongList.make, {
            getSongElementId: (function (param) {
              return "now-playing-queue-" + param;
            }),
            isQueueView: true,
            songIds: queuedSongIds
          }),
          className: css.bodyContainer
        }),
        className: css.body
      })
    ],
    className: css.root,
    id: id,
    onKeyDown: (function ($$event) {
      const match = $$event.code;
      if (match !== "Escape") {
        return;
      }
      $$event.preventDefault();
      $$event.stopPropagation();
      Curry._1(setIsOpen, (function (param) {
        return Stdlib__Fun.$$const(false, param);
      }));
    })
  });
}

const make = Queue;

export {
  make,
}
/* css Not a pure module */
